import firebase from 'firebase/app'
import 'firebase/firestore'

const config = {
  apiKey: "AIzaSyCfqZgn7_j3yaGLRQLtvwrbitqXlNqqc4s",
  authDomain: "mocskolodo.firebaseapp.com",
  databaseURL: "https://mocskolodo.firebaseio.com",
  projectId: "mocskolodo",
  storageBucket: "mocskolodo.appspot.com",
  messagingSenderId: "558357730568"
}

firebase.initializeApp(config)

export default firebase
